import util from '../util';

export const CURRENT_USER = 'CURRENT_USER';
export const CURRENT_USER_DEALER = 'CURRENT_USER_DEALER';
export const CURRENT_USER_DEALERS = 'CURRENT_USER_DEALERS';
export const USERS = 'USERS';
export const USER = 'USER';
export const CREATE_USER = 'CREATE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_DEALERS = 'UPDATE_USER_DEALERS';
export const UNLOCK_USER = 'UNLOCK_USER';
export const UPDATE_USER_PASSWORD = 'UPDATE_USER_PASSWORD';
export const RESET_USER = 'RESET_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const DELETE_USER = 'DELETE_USER';

export const CURRENT_USER_REQUEST = util.requestType(CURRENT_USER);
export const CURRENT_USER_SUCCESS = util.successType(CURRENT_USER);
export const CURRENT_USER_FAILURE = util.failureType(CURRENT_USER);

export const CURRENT_USER_DEALERS_REQUEST =
  util.requestType(CURRENT_USER_DEALERS);
export const CURRENT_USER_DEALERS_SUCCESS =
  util.successType(CURRENT_USER_DEALERS);
export const CURRENT_USER_DEALERS_FAILURE =
  util.failureType(CURRENT_USER_DEALERS);

export const CURRENT_USER_DEALER_REQUEST =
  util.requestType(CURRENT_USER_DEALER);
export const CURRENT_USER_DEALER_SUCCESS =
  util.successType(CURRENT_USER_DEALER);
export const CURRENT_USER_DEALER_FAILURE =
  util.failureType(CURRENT_USER_DEALER);

export const USER_REQUEST = util.requestType(USER);
export const USER_SUCCESS = util.successType(USER);
export const USER_FAILURE = util.failureType(USER);

export const USERS_REQUEST = util.requestType(USERS);
export const USERS_SUCCESS = util.successType(USERS);
export const USERS_FAILURE = util.failureType(USERS);

export const CREATE_USER_REQUEST = util.requestType(CREATE_USER);
export const CREATE_USER_SUCCESS = util.successType(CREATE_USER);
export const CREATE_USER_FAILURE = util.failureType(CREATE_USER);

export const UPDATE_USER_REQUEST = util.requestType(UPDATE_USER);
export const UPDATE_USER_SUCCESS = util.successType(UPDATE_USER);
export const UPDATE_USER_FAILURE = util.failureType(UPDATE_USER);

export const UPDATE_USER_DEALERS_REQUEST =
  util.requestType(UPDATE_USER_DEALERS);
export const UPDATE_USER_DEALERS_SUCCESS =
  util.successType(UPDATE_USER_DEALERS);
export const UPDATE_USER_DEALERS_FAILURE =
  util.failureType(UPDATE_USER_DEALERS);

export const UNLOCK_USER_REQUEST = util.requestType(UNLOCK_USER);
export const UNLOCK_USER_SUCCESS = util.successType(UNLOCK_USER);
export const UNLOCK_USER_FAILURE = util.failureType(UNLOCK_USER);

export const UPDATE_USER_PASSWORD_REQUEST =
  util.requestType(UPDATE_USER_PASSWORD);
export const UPDATE_USER_PASSWORD_SUCCESS =
  util.successType(UPDATE_USER_PASSWORD);
export const UPDATE_USER_PASSWORD_FAILURE =
  util.failureType(UPDATE_USER_PASSWORD);

export const DELETE_USER_REQUEST = util.requestType(DELETE_USER);
export const DELETE_USER_SUCCESS = util.successType(DELETE_USER);
export const DELETE_USER_FAILURE = util.failureType(DELETE_USER);
